import { isBrowser } from '../util';
export const storeSponsoredListings = (data) => {
    var _a;
    const sponsoredListing = [];
    (_a = data === null || data === void 0 ? void 0 : data.hotelSearchResults) === null || _a === void 0 ? void 0 : _a.hotels.forEach((hotel) => {
        const { isSponsored, conversionUrl, clickUrl } = (hotel === null || hotel === void 0 ? void 0 : hotel.pricingSummary) || {};
        if (isSponsored && conversionUrl) {
            const { estabId } = (hotel === null || hotel === void 0 ? void 0 : hotel.hotel) || {};
            sponsoredListing.push({ estabId, conversionUrl, clickUrl });
            if (!isBrowser()) {
                return;
            }
            const serialized = JSON.stringify({ sponsoredListing });
            window.localStorage.setItem('sponsoredListingPL195', serialized);
        }
    });
};
